import React, {PureComponent} from 'react';
import gettext from 'js-utils/gettext';

import SearchIconSvg from './SearchIconSvg';

import './searchNoResultsSuggestionsHeader.scss';

export default class SearchNoResultsSuggestionsHeader extends PureComponent {

    render() {
        return (
            <div className="search-no-results eds-align--center">
                <div className="eds-l-pad-all-2">
                    <SearchIconSvg />
                </div>
                <div className="eds-l-pad-top-6 eds-text-bm">
                    {gettext('No results found')}
                </div>
            </div>
        );
    }
}
